import { api } from './index';

export const promotionalCodesApi = {
  search(code: string, productId:number) {
    const params = `?code=${code}&product_id=${productId}`;
    const path = `/api/internal/promotional_codes/search${params}`;

    return api({
      method: 'get',
      url: path,
    });
  },
};
